export default {
  default: () => import("/home/nobuhiro/developments/v2.renjuportal/layouts/default.vue").then(m => m.default || m),
  image: () => import("/home/nobuhiro/developments/v2.renjuportal/layouts/image.vue").then(m => m.default || m)
}